<template>
  <div :class="[{'opacity-75':disabled}]">
    <div class="form-control" :class="id !== '' ? 'fc-'+id:'fc-'+randomId">
      <label
v-if="!disableLabel" :for="id !== '' ? id : randomId"
        :class="[{
          'translate-x-4 translate-y-[1rem] text-gray-500':!isFocused,
          'translate-x-3 translate-y-1 text-xs text-[#999999]': isFocused,
          'text-red-500':error || _error
          }]"
        class="absolute text-sm cursor-text transition bg-transparent p-1">
        {{label}}
        <span v-if="required">*</span>
      </label>
      <input
:id="id !== '' ? id : randomId" v-model="inputValue" type="text" :disabled="disabled"
        :class="[{
          'border-red-500 text-red-500 focus:outline-red-500 hover:border-red-500':error || _error,
          'focus:outline-f-primary-blue':!error,
          'cursor-not-allowed': disabled
        }]"
        class="input-md items-center inline-flex border rounded-md w-full bg-white hover:border-gray-700 pt-8 pb-6 disabled:border-gray-200 disabled:border-gray-200"
        autocomplete="off"
        :size="size" :maxlength="size" @input="validateRequired" @focus="isFocused = true" @blur="checkValue()" @change="checkValue()">
    </div>
    <div v-if="(!error && !_error) && helpText" class="text-xs text-gray-500 mt-1 ml-4">
      {{ helpText }}
    </div>
    <div v-if="error || _error" class="text-xs text-red-500 mt-1">
      {{ _error ? _error : error }}
    </div>
  </div>
</template>

<script setup>
import MakeId from '@/includes/MakeId';
const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  value: {
    type: String,
    default: '',
  },
  helpText: {
    type: String,
    default: '',
  },
  id: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: '30',
  },
  error: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  isSubmitting: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  disableLabel: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['onChange', 'onError']);
const randomId = 'input-' + MakeId(4);
const isFocused = ref(false);
const computedValue = ref('');
const inputValue = computed({
  get: () => {
    let val;
    if (computedValue.value !== '') {
      val = computedValue.value;
    } else {
      val = '';
    }
    return val;
  },
  set: (val) => {
    computedValue.value = val;
    return val;
  },

});
const _error = ref(null);

const checkValue = () => {
  if (inputValue.value === '') {
    isFocused.value = false;
  } else {
    isFocused.value = true;
  }
  if (props.required) validateRequired();
  if (props.error || _error.value) {
    emit('onError', props.error ? props.error : _error.value);
    return;
  }
  emit('onChange', inputValue.value);
};

const validateRequired = async () => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (inputValue.value.trim() === '') {
    _error.value = props.label + ' is required';
    emit('onError', props.error ? props.error : _error.value);
    return false;
  }

  if (!emailRegex.test(inputValue.value.trim())) {
    _error.value = 'Invalid email format';
    emit('onError', props.error ? props.error : _error.value);
    return false;
  }

  _error.value = null;
  emit('onChange', inputValue.value);
  emit('onError', _error.value);

  return true;
};

onMounted(() => {
  computedValue.value = props.value;
  if (inputValue.value) isFocused.value = true;
});

watch(() => inputValue.value, (val) => {
  if (val !== '') {
    isFocused.value = true;
  }
  validateRequired();
  if (props.error || _error.value) {
    emit('onError', props.error ? props.error : _error.value);
  }
});

watch(() => props.isSubmitting, (val) => {
  if (val === true && props.required) {
    validateRequired();
    if (props.error || _error.value) {
      emit('onError', props.error ? props.error : _error.value);
    }
  }
});
</script>

<style lang="scss" scoped>

</style>
